import { BASE_PATH } from '../../shared/types';
import { useMe } from '../lib/auth';
import { Brand } from '../components/Brand';
import { AccountMenu } from '../components/AccountMenu';

const SUPPORT_EMAIL = 'support@gatheredinforms.com';
const supportLink = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Help using Gathered In Forms')}`;

/** Help for families and organizers, separating questions about an activity from questions about this website. */
export function Help() {
  const { me } = useMe();
  return (
    <main class="container help-page">
      <div class="dashboard-brandbar"><Brand />{me && <AccountMenu email={me.email} isAdmin={me.isAdmin} />}</div>
      <header class="help-header"><p class="eyebrow">Help</p><h1>How can we help?</h1>
        <p class="muted">Questions about an activity go to its organizer. Questions about this website come to us.</p></header>

      <section class="help-section" aria-labelledby="help-activity">
        <h2 id="help-activity">Help with an activity</h2>
        <p>The organizer who sent you the registration link can answer questions about dates, what to bring, who may attend, and whether your registration arrived. Their name, phone number, and email are on the registration page and on the permission form.</p>
        <p>We can’t see registrations or answer for an organizer. Registrations go straight to the organizer’s own Google Drive.</p>
      </section>

      <section class="help-section" aria-labelledby="help-register">
        <h2 id="help-register">Registering a participant</h2>
        <ul>
          <li>Use the registration link your organizer sent you. There is no account to create and no list of activities to search.</li>
          <li>If the link says the registration isn’t available, open it again from the original message and check that the whole address was copied. If it still doesn’t work, registration may not be open yet. Ask your organizer.</li>
          <li>Your answers are saved in the browser tab as you go. Closing the tab clears them.</li>
        </ul>
      </section>

      <section class="help-section" aria-labelledby="help-organize">
        <h2 id="help-organize">Organizing an activity</h2>
        <ul>
          <li>You need an email address to sign in and a Google account to receive registrations in your own Drive.</li>
          <li>{me ? <a href={`${BASE_PATH}/dashboard`}>Your events</a> : <a href={`${BASE_PATH}/login`}>Sign in or create an event</a>} to start. Setup saves as you go, and the Review step lists anything left to finish.</li>
          <li>Families can’t use the registration link until you publish registration. Use the participant preview to try it yourself first.</li>
        </ul>
      </section>

      <section class="help-section" aria-labelledby="help-website">
        <h2 id="help-website">Help using this website</h2>
        <p>If a page isn’t working, or you’re stuck setting up an event, email us at <a href={supportLink}>{SUPPORT_EMAIL}</a>. The link opens a new message in your email app; nothing is sent until you send it. Please don’t include medical or other private registration details.</p>
        {me && <p>You can also <a href={`${BASE_PATH}/feedback`}>send feedback</a> from your account. You’ll see your message before it is sent.</p>}
      </section>
    </main>
  );
}
